(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fixednav", [], factory);
	else if(typeof exports === 'object')
		exports["fixednav"] = factory();
	else
		root["fixednav"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 